import { useEffect, useState } from "react";
import { Box, Dialog, DialogContent, IconButton } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import { useStyles } from "./style";
import { RootState } from "../../Redux/Reducers";
import { addToCart, setSelectedVariantModalVisibility } from "../../Redux/Actions";
import { mutateVariantItemWithCartData } from "../../Utils/common";
import CloseIcon from "../../Assets/images/black-close-icon.png";
import PlusIcon from "../../Assets/images/add.png";
import MinusIcon from "../../Assets/images/minus.png";

const VariantSelectedListModal = (): JSX.Element => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [state, setState] = useState({ itemCartIndex: -1 });
  const cartData = useSelector((state: RootState) => state.cartReducer.data);

  const {
    variant: { selectedVariantsModal },
    productLoaderId,
  } = useSelector((state: RootState) => state.commonReducer);

  useEffect(() => {
    if (selectedVariantsModal) {
      const productIndex = cartData.items.findIndex((el: { id: any }) => el.id === productLoaderId);
      setState((state) => ({ ...state, itemCartIndex: productIndex }));
      if (cartData && !cartData?.items[productIndex]) {
        onClose();
      }
    }
  }, [selectedVariantsModal, cartData, productLoaderId]);

  const onClose = () => {
    dispatch(setSelectedVariantModalVisibility(false));
  };

  const handleAddRemoveItem = (type: any, variantType: { variant_id: any; discounted_price: number }) => {
    const newCart = mutateVariantItemWithCartData(
      type,
      cartData?.items[state.itemCartIndex],
      variantType,
      cartData.items,
    );
    dispatch(addToCart({ items: newCart }));
  };

  const ifMaxVariantQuantity = (variant: { quantity: number; available_quantity: number }) =>
    variant.quantity === variant.available_quantity;

  const renderATCButton = (variant: any) => {
    return Number(variant.quantity) > 0 ? 
      <Box
        component="div"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        className="br-pill ba b--light-gray pv2 ph2 pointer"
        style={{ width: "6rem" }}
      >
        <Box component="span" display="flex" className="pointer">
          <img src={MinusIcon} onClick={() => handleAddRemoveItem("remove", variant)} width="12" />
        </Box>
        <Box component="p" className="mv0 f5 fw6">
          {Number(variant.quantity)}
        </Box>
        <Box component="span" display="flex" className="pointer">
          <img
            src={PlusIcon}
            onClick={() => !ifMaxVariantQuantity(variant) && handleAddRemoveItem("add", variant)}
            width="12"
            className={ifMaxVariantQuantity(variant) ? "o-50" : "o-100"}
          />
        </Box>
      </Box>
     : 
      <Box
        component="div"
        display="flex"
        alignItems="center"
        justifyContent="center"
        onClick={() => handleAddRemoveItem(undefined, variant)}
        className="br-pill ba b--light-gray pv2 ph1 pointer"
        style={{ width: "6rem" }}
      >
        <Box component="p" className="mv0 green fw6 f6">
          ADD +
        </Box>
      </Box>
    ;
  };

  return (
    <Dialog open={selectedVariantsModal} maxWidth="xs" fullWidth={true} onClose={onClose} className="relative">
      <IconButton
        color="primary"
        aria-label="Close Order Details Pop Up"
        component="span"
        className={classes.closeIcon}
        onClick={onClose}
      >
        <img src={CloseIcon} alt="close icon" loading="lazy" className="img h2" />
      </IconButton>
      <DialogContent>
        <Box component="h1" className="mb4">
          Choose Item to remove
        </Box>
        <Box component="section" className="mb3 relative">
          {cartData?.items[state.itemCartIndex]?.variants_selected?.map((variant: any, ind: number) => {
            return (
              <Box component="div" className="flex w-100 justify-between mb3" key={`items-variant-${ind}`}>
                <Box className="flex flex-column">
                  <Box component="p" className="mv0 f5 fw6">
                    {cartData?.items[state.itemCartIndex].name}
                  </Box>
                  <Box component="p" className="mv0 gray">
                    {variant.variant_name}
                  </Box>
                </Box>
                <article className="right">{renderATCButton(variant)}</article>
              </Box>
            );
          })}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default VariantSelectedListModal;
